
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/columns/sponsored",
      function () {
        return require("private-next-pages/columns/sponsored.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/columns/sponsored"])
      });
    }
  